// extracted by mini-css-extract-plugin
export default {"input":"each-station-forms_input__2Bjmp","selectInput":"each-station-forms_selectInput__eNx3R","textInput":"each-station-forms_textInput__G1AN8"};